<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-main class="main flex">
				<el-row :gutter="20" style="margin: 10px 0px;" v-loading = "staticloading">
					<el-col :span="6">
						<div>
							<el-statistic group-separator="" :precision="0" :value="statics.nazhinum"
								title="云系统数量"></el-statistic>
						</div>
					</el-col>
					<el-col :span="6">
						<div>
							<el-statistic group-separator="" :precision="0" :value="statics.yqdznum"
								title="亿企赢数量"></el-statistic>
						</div>
					</el-col>
				</el-row>
				<vxe-grid v-if="list_gridOptions" ref="inputinvoicereport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>		
			</el-main>
		</el-container>
		<invoiceConfig ref="invoiceConfig" :invoicedata="invoicedata" :tab="tab" />
		<createyqdzorder :data="currentrow" invoicetype="inputinvoice" ref="inputinvoiceCreateyqdzorder" />
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import invoiceConfig from './lib/invoice/index.vue'
	import createyqdzorder from './lib/createyqdzorder/index.vue'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				tab:['transferunit','matchinventory','inventory','invoicesuggestion'],
				invoicecompany:[],
				invoicedata:null,
				param:null,
				currentrow:null,
				loading:false,
				showUnsendjindie:false,
				showUnsendwln:false,
				showtransferaccount:false,
				transTime: null,
				reportName: 'outputinvoice',
				foreingKey:{},
				staticloading:false,
				statics:{
					nazhinum:0,
					yqdznum:0
				},
				list_formConfig: [{
					field: 'customerId',
					title: '我方公司',
					span: 4,
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[]
						}
					}
				},{
					field: 'supplierinvoicecode',
					title: '认领单',
					span: 4,
					itemRender: {
						name: '$input',
						props:{
							islist:true
						}
					}
				},{
					field: 'RKcode',
					title: '采购入库单',
					span: 4,
					itemRender: {
						name: '$input',
						props:{
							islist:true
						}
					}
				},{
					field: 'invoiceNumber',
					title: '发票编码',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'suplierName',
					title: '销方名称',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'taxItem',
					title: '征税项目',
					span: 4,					
					itemRender: {
						//defaultValue:'货物',
						name: '$input',
						props:{}
					}
				},{
					field: 'cargoName',
					title: '货物、应税劳务及服务',
					span: 4,					
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'ignore',
					title: '忽略',
					span: 4,					
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[{
								label:'是',
								value:1
							},{
								label:'否',
								value:0
							}]
						}
					}
				},{
					field: 'bizDate',
					title: '开票日期',
					span: 6,
					itemRender: {
						name: '$datePicker',
						props:{}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.invoice.listinputinvoice({
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
						...{
							fundtype:this.fundtype,
							bancktype:this.bancktype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						this.statics.nazhinum = res.nazhistatics.totalCount?res.nazhistatics.totalCount:0
						this.statics.yqdznum = res.yqdzstatics.totalRecord?res.yqdzstatics.totalRecord:0
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.customreload()
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.customreload()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},		
			createyqdzorder(row){
				this.currentrow = row
				this.$refs.inputinvoiceCreateyqdzorder.modal_show()
			},	
			deleteorderyqdzpurchaseorder(row){
				this.$confirm('是否确认删除？').then(()=>{
					this.loading = true
					this.$api.invoice.deleteorderyqdzpurchaseorder({
						data:row,
					}).then(()=>{
						this.loading = false
						this.customreload()
						this.$message.success('操作成功')
					},()=>{
						this.loading = false
					})
				})
				
			},
				
			list_beforeCreateGrid(gridOptions){
				return new Promise((reslove)=>{
					this.$api.invoice.listinvoicecompany().then((res) => {
						this.invoicecompany = res
						let customerId = this.list_formConfig.find((item)=>{
							return item.field == 'customerId'
						})
						if(customerId){
							customerId.itemRender.props.selectoptions = res.map((item)=>{
								return {
									value:item.customerId,
									label:item.customerName
								}
							})
						}
						gridOptions.id = 'inputinvoice_list'
						gridOptions.pagerConfig.enabled = true
						gridOptions.columns = [			
							// {type:'checkbox',title:'#',fixed:'left',width:50},
							{field:'invoiceNumber',title:'发票号码',render:'$input',props:{show:true},fixed:'left',width:150},
							{
								field:'customerId',
								title:'我方公司',
								render:'',
								formatter:({cellValue})=>{
									let target = this.invoicecompany.find((item)=>{
										return item.customerId == cellValue
									})
									if(target){
										return target.customerName
									}else{
										return cellValue
									}								
								},
								props:{show:true},
								width:100},
							{
								field:'invoiceClass',
								title:'发票种类',
								render:'$input',
								formatter:({cellValue})=>{
									if(cellValue == 31){
										return '数电票（专票）'
									}
									if(cellValue == 32){
										return '数电票（普票）'
									}									
								},
								props:{show:true},
								width:100,
							},
							{
								field:'bizDate',
								title:'开票日期',
								render:'$datePicker',
								formatter:({cellValue})=>{
									return window.systemMethods.timestampToDate(cellValue)
								},
								props:{show:true},
								width:100,
							},
							{
								field:'invoiceStatus',
								title:'发票状态',
								render:'',
								formatter:({cellValue})=>{
									if(cellValue == 0){
										return '正常'
									}
									if(cellValue == 3){
										return '红冲'
									}
									
								},
								props:{show:true},
								width:100,
							},
							{field:'cargoName',title:'货物、应税劳务及服务',sortable:true,render:'',props:{show:true},width:100},
							{field:'taxItem',title:'征税项目',render:'',props:{show:true},width:100},
							{field:'suplierName',title:'销方名称',render:'',props:{show:true},width:100,sortable:true},
							{field:'cargoPrice',title:'不含税金额',render:'',props:{show:true},width:100},		
							{field:'taxRates',title:'税率',render:'',props:{show:true},width:100},	
							{field:'taxPrice',title:'税额',render:'',props:{show:true},width:100},	
							{field:'totalPrice',title:'价税合计',render:'',props:{show:true},width:100},	
							{field:'drawerName',title:'开票人',render:'',props:{show:true},width:100},
							{field:'RKcode',title:'采购入库单',render:'',props:{show:true},width:100,fixed:'right'},		
							{field:'supplierinvoicecode',title:'认领单',render:'',props:{show:true},width:100,fixed:'right'},
							{
								field:'ignore',
								title:'忽略',
								render:'',
								cellRender:{
									name:'$switch',
									enabled:true,
									props:{
										openLabel:'是',
										closeLabel:'否',
										openValue:1,
										closeValue:0,
										size:'medium',
									},
									events:{
										change:({row})=>{
											this.ignoreChnage(row)
										}
									}
								},
								props:{show:true},
								width:100,
								fixed:'right',
							},																			
							{
								title: '操作',
								fixed: "right",
								align: 'center',
								width: 180,
								slots: {
									default: ({row}) => {
										return [
											<el-button style="color:#67C23A" type = "text" size = "mini" onClick = {() => {this.sourcefile(row)}}>原件</el-button>,
											<el-button style="color:#409EFF" type = "text" size = "mini" onClick = {() => {this.createyqdzorder(row)}}>生成入库</el-button>,
											<el-button style="color:#F56C6C" type = "text" size = "mini" onClick = {() => {this.deleteorderyqdzpurchaseorder(row)}}>删除入库</el-button>,
											// <el-button style="color:#F56C6C" type = "text" size = "mini" onClick = {() => {this.repurchase(row)}}>重新入库</el-button>,
											// <el-button type = "text" size = "mini" onClick = {() => {this.receipt(row)}}>回单</el-button>
										]
									}
								}
							}
						]
						gridOptions.checkboxConfig = null
						
						gridOptions.toolbarConfig.buttons = [{
							name: '导出',
							status: 'success',
							code: 'export'
						},{
							name: '同步发票',
							status: 'primary',
							code: 'getyqdzinvoice'
						}
						// {
						// 	name: '转存货',
						// 	status: 'primary',
						// 	code: 'transferinventory'
						// },
						// {
						// 	name: '重新入库',
						// 	status: 'danger',
						// 	code: 'repurchase'
						// },
						]
						
						
						gridOptions.columns.forEach((item)=>{
							if(item.field=='serialNo'){
								item.slots = {
									default: ({row}) => {	
										let str= []
										if(row.cdSign==1){
											str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
										}
										if(row.cdSign==0){
											str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
										}
										str.push(<span>{row.serialNo}</span>)
										return str
									}
								}
							}
							if(item.field=='export_wln'){
								item.slots = {
									default:({row})=>{
										if(!row.export_wln){
											if(row.export_wln_error){
												return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
											}else{
												return <span style="color:#F56C6C;">未同步</span> 							
											}	
										}else{
											return <span>{row.export_wln}</span> 	
										}
									}
								}
							}
							if(item.field=='export_jindie'){
								item.slots = {
									default:({row})=>{
										if(row.export_jindie_sucess!=1){
											if(row.export_jindie_error){
												return <span style="color:#F56C6C;">{row.export_jindie_error}</span> 
											}else{
												return <span style="color:#F56C6C;">未同步</span> 							
											}	
										}else{
											return <span style="color:#67C23A;">已同步</span> 	
										}
									}
								}
							}
						})
						reslove()
					})
				})
			},
			showstream(row){
				this.streamdata = row.stream
				this.$refs.skstream.modal_show()
			},
			ignoreChnage(row){
				this.$api.invoice.setinputinvoiceignore({
					id:row.id,
					ignore:row.ignore
				}).then(()=>{
					this.$message.success('操作成功')
				})
			},
			getyqdzinvoice(){
				let form = this.$refs.inputinvoicereport.getProxyInfo().form
				form = this.list_initupdateform(form)
				form.type = 'inputinvoice'
				this.loading = true
				this.$api.invoice.getyqdzinvoice(form).then(() => {
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})			
			},
			transferinventory(){
				let taxItem = true
				let suplierTaxs = []
				let customerIds = []
				let bizDates = []
				let data =  this.$refs.inputinvoicereport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					suplierTaxs.push(item.suplierTax)
					customerIds.push(item.customerId)
					bizDates.push(this.$Moment(item.bizDate * 1000).startOf('month').valueOf()/1000)
					if(item.taxItem!='货物'){
						taxItem = false
					}
				})
				if(!taxItem){
					this.$message.error('征税项目必须为【货物】')
					return
				}	
				suplierTaxs = [...new Set(suplierTaxs)]
				customerIds = [...new Set(customerIds)]
				bizDates = [...new Set(bizDates)]
				if(customerIds.length > 1){
					this.$message.error('我方公司必须一致')
					return
				}
				if(bizDates.length > 1){
					this.$message.error('开票月份必须一致')
					return
				}
				console.log(suplierTaxs)
				if(suplierTaxs.length > 1){
					this.$message.error('销方名称必须一致')
					return
				}
				let invoiceId = data.map((item)=>{
					return item.invoiceId
				})
				this.invoicedata = {
					customerId:customerIds[0],
					invoiceId:invoiceId.join(',')
				}
				this.tab = ['matchinventory','inventory','invoicesuggestion']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
				
			},
			sourcefile(row) {
				this.invoicedata = {
					customerId:row.customerId,
					invoiceNumber:row.invoiceNumber,
					invoiceId:row.invoiceId,
					invoiceType:0
				}
				this.tab = ['invoice']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})

				
			},
			settlement(row) {
				let handle = this.$loading()
				this.$api.reconciliationcurrent.settlement({
					id: row.id,
					wlnid: row.purchasesupplierid,
					purchasecode: row.serialNo
				}).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()

				}, () => {
					this.$loadingclose(handle)
				})
				console.log(row)
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('haspaper') !== -1) {
					if (row.haspaper == 6) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.haspaper == 5) {
						return {
							color: '#67C23A'
						}
					}
				}
			},
			paymentsummary() {
				let form = this.$refs.inputinvoicereport.getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},
			custommark(row){
				this.$prompt('请输入内容【'+row.serialNo+'】','提示').then(({ value })=>{
					this.$api.reconciliation_bankflow.custommark({
						fundtype:this.fundtype,
						bancktype:this.bancktype,
						custommark:value,
						id:row.id
					}).then(() => {
						row.custommark = value
					})
				})
			},
			repurchase(row){
				let data =  this.$refs.inputinvoicereport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				
				this.$confirm('是否确认重新入库，需手动删除亿企赢采购入库单', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let invoiceId = data.map((item)=>{
						return item.invoiceId
					})
					this.$api.invoice.repurchase({invoiceId:invoiceId}).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {
				
				})
				console.log(row)
			},
			edit(row){
				// if(row.relationtype == 1){
				// 	this.$message.error('自动关联的流水无法编辑')
				// 	return
				// }
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			customreload(){
				this.$refs.inputinvoicereport.commitProxy('query')
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs.inputinvoicereport.getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			invoiceConfig,
			createyqdzorder
			// exportTable,
			// receiptIndex,
			// statisticsIndex,
			// editIndex
		}
	}
</script>